import { LinesController } from "./LinesController";
export class ShadersCollectionController {
  constructor(_shaderNames, _currentShaderName, _assembler) {
    this._shaderNames = _shaderNames;
    this._currentShaderName = _currentShaderName;
    this._assembler = _assembler;
    this._linesControllerByShaderName = /* @__PURE__ */ new Map();
    for (let shaderName of this._shaderNames) {
      this._linesControllerByShaderName.set(shaderName, new LinesController(shaderName));
    }
  }
  assembler() {
    return this._assembler;
  }
  linesController(shaderName) {
    return this._linesControllerByShaderName.get(shaderName);
  }
  shaderNames() {
    return this._shaderNames;
  }
  setCurrentShaderName(shaderName) {
    this._currentShaderName = shaderName;
  }
  currentShaderName() {
    return this._currentShaderName;
  }
  addDefinitions(node, definitions, shaderName) {
    if (definitions.length == 0) {
      return;
    }
    shaderName = shaderName || this._currentShaderName;
    const lines_controller = this._linesControllerByShaderName.get(shaderName);
    if (lines_controller) {
      lines_controller.addDefinitions(node, definitions);
    }
  }
  definitions(shader_name, node) {
    const lines_controller = this._linesControllerByShaderName.get(shader_name);
    if (lines_controller) {
      return lines_controller.definitions(node);
    }
  }
  traverseDefinitions(shaderName, callback) {
    const lines_controller = this._linesControllerByShaderName.get(shaderName);
    if (lines_controller) {
      lines_controller.traverseDefinitions(callback);
    }
  }
  addBodyLines(node, lines, shaderName, options) {
    if (lines.length == 0) {
      return;
    }
    shaderName = shaderName || this._currentShaderName;
    const lines_controller = this._linesControllerByShaderName.get(shaderName);
    if (lines_controller) {
      lines_controller.addBodyLines(node, lines, options);
    }
  }
  bodyLines(shaderName, node) {
    const lines_controller = this._linesControllerByShaderName.get(shaderName);
    if (lines_controller) {
      return lines_controller.bodyLines(node);
    }
  }
}
